import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "love-it-list-header-cell",
    templateUrl: "./list-header-cell.component.html",
    styleUrls: ["./list-header-cell.component.scss"],
    standalone: false
})
export class ListHeaderCellComponent implements OnInit {
  @Input() column: any;
  @Input() sortFunc: () => void;
  @Input() sortDir: string;

  constructor() {}

  ngOnInit(): void {}
}
